var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2MultiwireSetupDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A2_Multiwire_Setup_diagram_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 42h4v23H0V30.22L13.57 16H54v4H15v12H4v29h54V42zm17.25-20.87l-.06.06a.573.573 0 01-.11.11l-.14.14L59 37.64l-.07.07-11.99 3.14 3.48-11.71 16.22-16.28.27-.28c1.77-1.65 5-1 7.21 1.44s2.59 5.39 1.13 7.11zM56.24 35l-3.48-3.48-1.4 3.58c.38.066.729.247 1 .52.2.197.354.436.45.7L56.24 35zm15.28-16.51l-2.11-2.13-2.55 2.52-10.16 10L58.81 31l10.12-10 2.59-2.51zM33 55v-7h-4v7H17V36.68l13.82-9.32L45 36.68V55H33zm-6-16h-4v4h4v-4zm8 4h4v-4h-4v4z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A2_Multiwire_Setup_diagram_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/A2_Multiwire_Setup_diagram.ec387d93.svg";
export { SvgA2MultiwireSetupDiagram as ReactComponent };